import React from 'react';

const ClockIcon = ({ ...props }) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 32 32">
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.75 1.07a14.71 14.71 0 1 1 .02 29.43 14.71 14.71 0 0 1-.02-29.43Zm-.13 26.8a12.09 12.09 0 0 1 .19-24.18 12.08 12.08 0 1 1-.2 24.17Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M15.78 8.05c.73 0 1.31.6 1.31 1.32v5.8l4.8 4.21a1.31 1.31 0 1 1-1.73 1.98l-5.25-4.6a1.31 1.31 0 0 1-.45-.99v-6.4c0-.73.6-1.32 1.32-1.32Z"
      clipRule="evenodd"
    />
  </svg>
);

export default ClockIcon;
